import { render, staticRenderFns } from "./order_form_list.vue?vue&type=template&id=4ee0b25e&scoped=true&"
import script from "./order_form_list.vue?vue&type=script&lang=tsx&"
export * from "./order_form_list.vue?vue&type=script&lang=tsx&"
import style0 from "./order_form_list.vue?vue&type=style&index=0&id=4ee0b25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee0b25e",
  null
  
)

export default component.exports